export default function ShowcaseSection() {
  return (
    <section className="relative py-32 px-6 bg-gradient-to-b from-[#1a0b2e] to-[#0a0a0f] overflow-hidden">
      {/* Background Glow */}
      <div className="absolute inset-0">
        <div
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full"
          style={{
            background: 'radial-gradient(circle, rgba(139, 92, 246, 0.15) 0%, transparent 70%)',
            filter: 'blur(80px)',
          }}
        />
      </div>

      <div className="relative max-w-7xl mx-auto">
        {/* Content */}
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-black mb-6">
            <span className="bg-gradient-to-r from-cyan-400 via-purple-400 to-pink-400 bg-clip-text text-transparent">
              Autonomous Business Processes
            </span>
          </h2>
          <p className="text-2xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            Your business processes become fully autonomous.
            <br />
            <span className="text-purple-400 font-semibold">
              Watch your workflows connect and execute in real-time.
            </span>
          </p>
        </div>

        {/* Feature Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            {
              icon: 'ri-speed-line',
              title: 'Real-Time Execution',
              description: 'Processes execute instantly across your entire infrastructure',
            },
            {
              icon: 'ri-shield-check-line',
              title: 'Self-Healing',
              description: 'Automatic error detection and recovery mechanisms',
            },
            {
              icon: 'ri-line-chart-line',
              title: 'Intelligent Scaling',
              description: 'Adapts to workload demands automatically',
            },
          ].map((feature, index) => (
            <div
              key={index}
              className="p-6 rounded-xl bg-gradient-to-br from-purple-900/20 to-transparent border border-purple-500/20 backdrop-blur-sm hover:border-purple-400/40 transition-all duration-300 cursor-pointer group"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-gradient-to-br from-purple-500 to-cyan-500 mb-4 group-hover:scale-110 transition-transform duration-300">
                <i className={`${feature.icon} text-2xl text-white`} />
              </div>
              <h3 className="text-xl font-bold text-white mb-2">{feature.title}</h3>
              <p className="text-gray-400">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
